import { useMutation } from "@apollo/client";
import { CreateConsentMutation, CreateConsentMutationVariables } from "@ctypes";
import { USER } from "@graphql";
import { CREATE_CONSENT } from "@graphql/mutations";

/**
 * Records the user's e-signature against an agreement. Refetches USER because approving the
 * Capital Group migration flips the flag that decides whether the consent modal shows.
 */
export const useCreateConsent = () => {
  return useMutation<CreateConsentMutation, CreateConsentMutationVariables>(CREATE_CONSENT, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
  });
};
